import React, { useRef, useState } from "react";
import "../styles/Contact.css";
import emailjs from "@emailjs/browser";

function Contact() {
  const form = useRef();
  const [status, setStatus] = useState("");
  const [isSending, setIsSending] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSending(true);

    emailjs
      .sendForm(
        "service_1b12zbt",
        "template_cr3wxuw",
        form.current,
        "TaUuiWrNJ38WzNtaw",
      )
      .then(
        () => {
          setStatus("success");
          setIsSending(false);
          e.target.reset();
          setTimeout(() => setStatus(""), 2500);
        },
        () => {
          setStatus("error");
          setIsSending(false);
          setTimeout(() => setStatus(""), 2500);
        },
      );
  };

  return (
    <div className="contact-page">
      <h1 className="contact-title">Contact Us</h1>
      <div className="contact-container">
        <div className="contact-info">
          <h2>MKAI Karate</h2>
          <h2>Head Branch </h2>
          <p>
            No: 48/53, Rajarajeswari Nagar,
            <br />
            Kolathur, Chennai - 600099.
          </p>
          <p>
            <strong>Email:</strong> mkaidojo.india@gmail.com
          </p>
          <p>
            <strong>Phone:</strong> 96000 41923
          </p>
        </div>

        <div className="contact-form-wrapper">
          {status === "success" && (
            <div className="status success">
              Thanks for reaching out to MKAI Karate Kolathur.
            </div>
          )}
          {status === "error" && (
            <div className="status error">
              We're sorry, your message couldn't be sent right now.
              <br />
              Please try again later or contact us directly at{" "}
              <strong>Mkaidojo.india@gmail.com</strong>.
            </div>
          )}

          <form ref={form} onSubmit={sendEmail}>
            <label>Name</label>
            <input type="text" name="user_name" required />

            <label>Email</label>
            <input type="email" name="user_email" required />

            <label>Message</label>
            <textarea name="message" rows="5" required />

            <button type="submit" disabled={isSending}>
              {isSending ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
